import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { StoreComponent } from './store/StoreContext';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
	<StoreComponent>
		<App />
	</StoreComponent>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
